import { createSlice } from '@reduxjs/toolkit';
import type { Inventory } from '~/graphql/graphql';

type InventoryState = {
  inventory: Inventory | null;
};

const initialState: InventoryState = {
  inventory: null,
};

const inventorySlice = createSlice({
  name: 'inventory',
  initialState,
  reducers: {
    setInventory(state, action) {
      state.inventory = action.payload;
    },
  },
});

export const { setInventory } = inventorySlice.actions;
export default inventorySlice.reducer;
